import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
var NglDatepickerYear = (function () {
    function NglDatepickerYear() {
        // How many years before and after the current one are selectable in dropdown
        this.numYearsBefore = 100;
        this.numYearsAfter = 10;
        this.yearChange = new EventEmitter();
    }
    Object.defineProperty(NglDatepickerYear.prototype, "setYear", {
        set: function (year) {
            this.year = +year;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NglDatepickerYear.prototype, "range", {
        get: function () {
            var currentYear = (new Date()).getFullYear();
            var firstYear = Math.min(currentYear - this.numYearsBefore, this.year);
            var size = Math.max(currentYear + this.numYearsAfter, this.year) - firstYear;
            return Array.apply(null, { length: size + 1 }).map(function (value, index) { return firstYear + index; });
        },
        enumerable: true,
        configurable: true
    });
    NglDatepickerYear.prototype.change = function ($event) {
        this.yearChange.emit($event);
    };
    NglDatepickerYear.decorators = [
        { type: Component, args: [{
                    selector: 'ngl-date-year',
                    template: "\n    <div class=\"slds-select_container\"><select class=\"slds-select\" [ngModel]=\"year\" (ngModelChange)=\"change($event)\"><option *ngFor=\"let yr of range\" [value]=\"yr\">{{yr}}</option></select></div>\n  ",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                },] },
    ];
    /** @nocollapse */
    NglDatepickerYear.ctorParameters = function () { return []; };
    NglDatepickerYear.propDecorators = {
        'numYearsBefore': [{ type: Input },],
        'numYearsAfter': [{ type: Input },],
        'setYear': [{ type: Input, args: ['year',] },],
        'yearChange': [{ type: Output },],
    };
    return NglDatepickerYear;
}());
export { NglDatepickerYear };
//# sourceMappingURL=year.js.map